
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherCurvePoint } from './GenWeatherCurvePoint';

export class GenWeatherCurve {

    averageEscalation: number;
    averagePeak: number;
    averageRecovery: number;
    category: string;
    meanNrmse: number;
    points: GenWeatherCurvePoint[];
    support: string;
    supportingEvents: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherCurve: GenWeatherCurve);

    constructor( input?: GenWeatherCurve ) {
        if ( input && typeof input !== 'number' ) {
            this.averageEscalation = input.averageEscalation; // float [number]
            this.averagePeak = input.averagePeak; // float [number]
            this.averageRecovery = input.averageRecovery; // float [number]
            this.category = input.category; // string [string]
            this.meanNrmse = input.meanNrmse; // float [number]
            if ( input.points && input.points.map ) { // list [GenWeatherCurvePoint]
                this.points = input.points.map( ( x: GenWeatherCurvePoint ) => {
                    return new GenWeatherCurvePoint( x );
                } );
            } else {
                this.points = input.points;
            }
            this.support = input.support; // string [string]
            this.supportingEvents = input.supportingEvents; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherCurve[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherCurve(a));
        } else {
          return [];
        }
    }
}

